import React, { useState } from "react";
import { ConfigFeedback } from "../../pages";
import constant from "../../utils/constant";
import { FeedbackController } from "../../controllers";
import { MimaToastUtil } from "../../components";

const ConfigFeedbackContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (payload) => {
    setLoading(true);
    const { status, errorMessage } =
      await FeedbackController.createFeedbackKey(payload);
    if (status === constant.Success) {
      setLoading(false);
      closeModal();
      MimaToastUtil.success({
        message: constant.Success,
      });
    } else {
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    setLoading(false);
    return;
  };

  return (
    <ConfigFeedback
      closeModal={closeModal}
      loading={loading}
      onSubmit={onSubmit}
    />
  );
};
export default ConfigFeedbackContainer;
